import {ReactNode} from 'react'
import {Radio} from 'antd'
import {MenuInfo} from 'rc-menu/lib/interface'

import {Dropdown, Text} from 'common/components'

interface SortProps {
  children: ReactNode
  alignRightDropdown?: boolean
  sort: string
  items: Item[]
  setSort: (sort: string) => void
}

interface Item {
  label: string
  key: string
}

export default function Sort({
  children,
  alignRightDropdown,
  sort,
  items,
  setSort,
}: SortProps) {
  const handleClick = ({key}: MenuInfo) => setSort(key)

  return (
    <Dropdown
      menu={{
        items: items.map((item) => ({
          ...item,
          label: (
            <Radio checked={item.key === sort}>
              <Text as="span" weight="regular">
                {item.label}
              </Text>
            </Radio>
          ),
        })),
        onClick: handleClick,
      }}
      placement={alignRightDropdown ? 'bottomRight' : undefined}
    >
      {children}
    </Dropdown>
  )
}
